<template>
  <div class="modal fade in" tabindex="-1" role="dialog" :class="onClass" style="display: block; padding-right: 17px;">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" :class="size">
          <div class="modal-content">
              <div class="modal-header d-flex align-items-center border-bottom">
                <slot name="header"></slot>
              </div>
              <div class="modal-body">
                <slot name="body"></slot>
              </div>
              <div class="modal-footer">
                <slot name="footer"></slot>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    onClass: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'modal-lg'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/model.vue